<template>
    <div class="row">
        <div class="col-lg-12">
            <b-table
                show-empty
                empty-text="ไม่มีรายละเอียดข้อมูลร้านค้า"
                ref="rateManagement" 
                responsive
                selectable
                :items="itemRateManagement"
                :fields="fields"
                @row-selected="onRowSelected"
                class="scroll-bar-pop"
            >
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="HEAD_selected">
                  <b-form-checkbox v-model="checkSelect" @change="selectAllRows()" class="text-center"></b-form-checkbox>
                </template>
                <template 
                  slot="selected" 
                  slot-scope="{ rowSelected }"
                >
                    <template v-if="rowSelected">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" autocomplete="off" class="custom-control-input" value="true" checked>
                        <label class="custom-control-label"></label>
                      </div>
                    </template>
                    <template v-else>
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" autocomplete="off" class="custom-control-input" value="false">
                        <label class="custom-control-label"></label>
                      </div>
                    </template>
                </template>
                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                <template slot="name" slot-scope="row">
                    {{ (row.item.name) ? row.item.name : '-' }}
                </template>
                <template slot="package" slot-scope="row">
                    {{ (row.item.package) ? row.item.package : '-' }}
                </template>
                <template slot="default_courier_code" slot-scope="row">
                    {{ (row.item.default_courier_code) ? row.item.default_courier_code : '-' }}
                </template>
                <template slot="under_by" slot-scope="row">
                    {{row.item.under_by.under_by.toUpperCase()}}
                </template>
                <template slot="effective_date" slot-scope="row">
                    {{ (row.item.effective_date) ? row.item.effective_date : '-' }}
                </template>
                 <template slot="expired_date" slot-scope="row">
                    {{ (row.item.expired_date) ? row.item.expired_date : '-' }}
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        itemRateManagement: Array,
        disabledForSuperAdmin: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return{
            selectedShop: [],
            checkSelect: false,
        }
    },
    methods: {
        onRowSelected(items) {
            let listSelectedShop = []
           
            items.forEach((items, index) => {
                listSelectedShop.push(items.shop_code)
            })

            this.selectedShop = listSelectedShop
        },
        selectAllRows() {
            this.checkSelect = !this.checkSelect
            if(this.checkSelect){
                this.$refs.rateManagement.selectAllRows()
            }else{
                this.$refs.rateManagement.clearSelected()
            }
        }
    },
    computed: {
        fields(){ 
            let fields = [
                { key: "selected", label: "เลือกรายการ", class: "text-center" },
                { key: "index", label: "ลำดับ", sortable: true },  
                { key: "shop_code", label: "รหัสร้านค้า", sortable: true },
                { key: "shop_name", label: "ชื่อร้านค้า", sortable: true },
                { key: "default_courier_code", label: "รหัสเรทราคา", sortable: true },
                { key: "name", label: "ชื่อขนส่ง", sortable: true },
                { key: "package", label: "ระดับแพ็กเกจ", sortable: true },
                { key: "under_by", label: "ภายใต้", sortable: true },
                { key: "effective_date", label: "วันที่เริ่มใช้", sortable: true },
                { key: "expired_date", label: "วันที่สิ้นสุด", sortable: true },
            ]
            let fieldforSuperadmin = [
                { key: "selected", label: "เลือกรายการ", class: "text-center" },
                { key: "index", label: "ลำดับ", sortable: true },  
                { key: "shop_code", label: "รหัสร้านค้า", sortable: true },
                { key: "shop_name", label: "ชื่อร้านค้า", sortable: true },
                { key: "default_courier_code", label: "รหัสเรทราคา", sortable: true },
                { key: "name", label: "ชื่อขนส่ง", sortable: true },
                { key: "package", label: "ระดับแพ็กเกจ", sortable: true },
                { key: "effective_date", label: "วันที่เริ่มใช้", sortable: true },
                { key: "expired_date", label: "วันที่สิ้นสุด", sortable: true },
            ]
            return this.disabledForSuperAdmin ?  fieldforSuperadmin : fields
        },
    }
}
</script>